export default __webpack_public_path__ + "static/media/verified.4f25f0d0.svg";